const checkStatus = res => {
  if (res.status >= 200 && res.status < 300) {
    return res
  } else {
    throw new Error(`${res.status}: ${res.statusText}`)
  }
}

export const sendRecaptchaData = token => {
  const formData = new FormData()

  formData.append('g-recaptcha-response', token)

  return fetch('https://selectel.ru/api/recaptcha', {
    method: 'POST',
    body: formData
  })
  .then(checkStatus)
}